import { Column } from '@ui-components/table';
import { UserToReassign, UserToReassignV2 } from '../../common/types/UserToReassign';

export const reassignConfig: Column<UserToReassign>[] = [
  {
    title: 'Full Name',
    key: 'fullName',
    dataIndex: 'name',
    sortable: true,
    defaultSort: 'asc',
    customRender: (rowData) => rowData?.name || ''
  },
  {
    title: 'Email',
    key: 'email',
    dataIndex: 'email',
    sortable: true,
    defaultSort: 'asc',
    customRender: (rowData) => rowData?.email || ''
  },
  {
    title: 'Vendor',
    key: 'vendor',
    dataIndex: 'vendor',
    sortable: true,
    defaultSort: 'asc',
    customRender: (rowData) => rowData?.vendor || ''
  }
];


export const reassignConfigV2: Column<UserToReassignV2>[] = [
  {
    title: 'Display Name',
    key: 'displayName',
    dataIndex: 'displayName',
    sortable: true,
    defaultSort: 'asc',
    customRender: (rowData) => rowData?.displayName || ''
  },
  {
    title: 'Email',
    key: 'email',
    dataIndex: 'email',
    sortable: true,
    defaultSort: 'asc',
    customRender: (rowData) => rowData?.email || ''
  },
  {
    title: 'Organization',
    key: 'organization',
    dataIndex: 'organization',
    sortable: true,
    defaultSort: 'asc',
    customRender: (rowData) => rowData?.organization || ''
  }
];
